<template>
    <div class="card mb-1">
        <div class="card-body p-0">

            <div class="box-header">
                <a class="d-block" data-toggle="collapse" href="#collapseResume" aria-expanded="false"
                   aria-controls="collapseResume">
                    <h6 class="box-title p-3 m-0"><i class="fa fa-tachometer"></i> Order Approval Queue</h6>
                </a>
            </div>

            <div class="collapse show pl-3 pr-3 pb-3 pt-2" id="collapseResume">
                <div>
                    <div class="row mb-2" v-if="isMonth">
                        <div class="col-md-6"></div>
                        <div class="col-md-3">
                            <select v-model="filter.month"
                                    class="form-control">
                                <option v-for="(month, index) in monthNames" :value="index+1" :key="index">{{
                                        month
                                    }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <select v-model="filter.year" class="form-control">
                                <option v-for="year in years(2015, 2026)" :key="year">{{ year }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="row">

                        <site-card-component
                            col="2"
                            color="bg-gradient-info"
                            value="0"
                            filter="ID"
                            :year="filter.year"
                            :month="filter.month"
                            :other-params="this.otherParams"
                            name="Orders Due"
                            :actions="true">
                            <template v-slot:dropdown-item>
                                <a :href="`sites?filter=ID&month=${filter.month}&year=${filter.year}`" class="dropdown-item">Filter
                                    orders</a>
                                <a href="#" @click="approve(filter.year, filter.month)" class="dropdown-item">Approve
                                    orders</a>
                                <a href="#" class="dropdown-item">Check Proposal Needed</a>
                            </template>
                        </site-card-component>
                        <site-card-component
                            col="2"
                            color="bg-gradient-success"
                            value="0"
                            :year="filter.year"
                            :month="filter.month"
                            filter="IA"
                            :other-params="this.otherParams"
                            name="Orders Approved"
                            :actions="true">
                            <template v-slot:dropdown-item>
                                <a :href="`sites?filter=IA&month=${filter.month}&year=${filter.year}`" class="dropdown-item">Filter
                                    orders</a>
                            </template>

                        </site-card-component>
                        <site-card-component
                            col="3"
                            color="bg-gradient-danger"
                            value="0"
                            :year="filter.year"
                            :month="filter.month"
                            :other-params="this.otherParams"
                            filter="IANS"
                            name="Approved not Scheduled"
                            :actions="true">
                            <template v-slot:dropdown-item>
                                <a :href="`sites?filter=IANS&month=${filter.month}&year=${filter.year}`"
                                   class="dropdown-item">Filter
                                    orders</a>
                            </template>
                        </site-card-component>
                        <site-card-component
                            col="3"
                            color="bg-gradient-primary"
                            value="0"
                            :year="filter.year"
                            :month="filter.month"
                            filter="IAAS"
                            name="Approved and Scheduled"
                            :other-params="this.otherParams"
                            :actions="true">
                            <template v-slot:dropdown-item>
                                <a :href="`sites?filter=IAAS&month=${filter.month}&year=${filter.year}`"
                                   class="dropdown-item">Filter orders</a>
                            </template>

                        </site-card-component>
                        <site-card-component
                            col="2"
                            color="bg-gradient-danger"
                            value="0"
                            :year="filter.year"
                            :month="filter.month"
                            filter="PID"
                            name="Proposal in draft"
                            :other-params="this.otherParams"
                            :actions="true">
                            <template v-slot:dropdown-item>
                                <a :href="`sites?filter=PID&month=${filter.month}&year=${filter.year}`"
                                   class="dropdown-item">Filter orders</a>
                            </template>

                        </site-card-component>
                    </div>
                    <div class="row">
                        <site-header-summary-component  :year="filter.year"
                                                        :month="filter.month">

                        </site-header-summary-component>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {monthNames, URL_BASE, years} from '../../../utils/helper';

export default {
    name: "SiteHeaderComponent",
    props: {
        'month': {
            type: String,
            required: false,
        },
        'year': {
            type: String,
            required: false,
        },
        'otherParams': {
            type: Object,
            required: false,
        },
        'isMonth': {
            type: Boolean,
            required: false,
            default: true,
        }
    },
    data() {
        return {
            monthNames: [],
            filter: {
                month: (new Date()).getMonth() + 1,
                year: (new Date()).getFullYear(),
            }
        }
    },
    mounted() {
        this.monthNames = monthNames
        if (this.year) {
            this.filter.year = this.year
        }
        if (this.month) {
            this.filter.month = this.month
        }

        if (!this.isMonth){
            this.filter.month = null
        }
    },
    methods: {
        years: years,
        approve(year, month) {
            approveInspections(year, month)
        }
    }
}


</script>

<style scoped>
.card .box-header a:hover {
    background-color: #eee !important;
    border-bottom: 0;
    text-decoration: none;
}

select {
    height: 37px;
}
</style>
